import { locale } from '@trqk/utils';

import { dataSourceLocaleStringOptions } from '../../../constants';
import { getGapDataSourceLabels } from '../../../utils';

const errorMessages =
    locale.enUS.MANAGE_GAP_ANALYSIS.STEPS.ANALYZING_DATA.ERROR_MESSAGES;

export const getEmptyDataMessage = (
    selectedPeriod: GapAnalysisPeriodSelection | null,
): string => {
    let warning = errorMessages.EMPTY_DETECTIONS.WARNING_FOR_SELECTED_PERIOD;

    const sourceLabels = getGapDataSourceLabels({
        localeStringOptions: dataSourceLocaleStringOptions,
        selectedPeriod,
        trqkGap: null,
    });

    if (sourceLabels.performances.dateRange) {
        warning = `${errorMessages.EMPTY_DETECTIONS.WARNING_FOR_DATE_RANGE} ${sourceLabels.performances.dateRange}.`;
    }

    return `${warning} ${errorMessages.EMPTY_DETECTIONS.EXPLANATION}`;
};
